export default {
  WELCOME_TO_REACT: "Bienvenue to React and react-i18next",
}
